(function () {
  'use strict';

  var cfg = window.StutiPDP || {};
  var BASE_PRICE        = Number(cfg.basePrice)        || 0;
  var FINISHING_PRICE   = Number(cfg.finishingPrice)   || 150;
  var FINISHING_HOURS   = Number(cfg.finishingHours)   || 48;
  var FINISHING_VARIANT_ID = 48661199880427;
  var HAS_STOCK         = cfg.hasStock !== false;
  var PRODUCT_SKU       = cfg.productSku || 'default';
  var CUTOFF_START      = Number(cfg.dispatchCutoffStart) || 9;
  var CUTOFF_END        = Number(cfg.dispatchCutoffEnd)   || 16;

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {

    function shopifyCentered(url, w, h) {
      if (!url) return url;
      var sep = url.indexOf('?') >= 0 ? '&' : '?';
      return url + sep + 'width=' + w + '&height=' + h + '&crop=center';
    }
    // First image keeps natural aspect ratio (matches standard product page).
    // Only paired images get the 3:4 crop.
    document.querySelectorAll('.gallery-col .frame-pair .frame img').forEach(function (img) { img.src = shopifyCentered(img.src, 900, 1200); });
    document.querySelectorAll('.mobile-gallery .slide').forEach(function (slide) {
      var url = slide.dataset.src;
      if (url) slide.style.backgroundImage = "url('" + shopifyCentered(url, 700, 933) + "')";
    });
    document.querySelectorAll('.collection .card .img, .rail-card .inner-img').forEach(function (el) {
      var bg = el.style.backgroundImage;
      var m = bg.match(/url\(['"]?(.*?)['"]?\)/);
      if (m && m[1]) el.style.backgroundImage = "url('" + shopifyCentered(m[1], 500, 667) + "')";
    });

    var scroll = document.querySelector('.mobile-gallery .scroll');
    var dots = document.querySelectorAll('.mobile-gallery .dot');
    var count = document.querySelector('.mobile-gallery .count');
    if (scroll) {
      scroll.addEventListener('scroll', function () {
        var idx = Math.round(scroll.scrollLeft / scroll.clientWidth);
        dots.forEach(function (d, i) { d.classList.toggle('active', i === idx); });
        if (count) count.textContent = (idx + 1) + ' / ' + dots.length;
      });
    }

    var lightbox  = document.getElementById('lightbox');
    var lbImg     = document.getElementById('lightbox-img');
    var lbCounter = document.getElementById('lb-counter');
    var lbClose   = document.getElementById('lb-close');
    var lbPrev    = document.getElementById('lb-prev');
    var lbNext    = document.getElementById('lb-next');
    if (lightbox && lbImg) {
      var sources = [];
      document.querySelectorAll('[data-src]').forEach(function (el) { if (sources.indexOf(el.dataset.src) === -1) sources.push(el.dataset.src); });
      var lbIdx = 0;
      function openLightbox(src) { lbIdx = Math.max(0, sources.indexOf(src)); showLb(); lightbox.classList.add('active'); lightbox.setAttribute('aria-hidden','false'); document.body.style.overflow = 'hidden'; }
      function closeLightbox() { lightbox.classList.remove('active'); lightbox.setAttribute('aria-hidden','true'); lbImg.classList.remove('zoomed'); lbImg.style.transformOrigin = '50% 50%'; document.body.style.overflow = ''; }
      function showLb() { lbImg.src = sources[lbIdx]; if (lbCounter) lbCounter.textContent = (lbIdx + 1) + ' / ' + sources.length; lbImg.classList.remove('zoomed'); lbImg.style.transformOrigin = '50% 50%'; }
      function lbStep(dir) { lbIdx = (lbIdx + dir + sources.length) % sources.length; showLb(); }
      document.querySelectorAll('.gallery-col .frame, .mobile-gallery .slide').forEach(function (el) {
        el.addEventListener('click', function (e) { e.preventDefault(); openLightbox(el.dataset.src); });
      });
      if (lbClose) lbClose.addEventListener('click', closeLightbox);
      if (lbPrev)  lbPrev.addEventListener('click', function (e) { e.stopPropagation(); lbStep(-1); });
      if (lbNext)  lbNext.addEventListener('click', function (e) { e.stopPropagation(); lbStep(1); });
      lightbox.addEventListener('click', function (e) { if (e.target === lightbox || (e.target.classList && e.target.classList.contains('frame-wrap'))) closeLightbox(); });
      lbImg.addEventListener('click', function (e) { e.stopPropagation(); lbImg.classList.toggle('zoomed'); if (!lbImg.classList.contains('zoomed')) lbImg.style.transformOrigin = '50% 50%'; });
      lbImg.addEventListener('mousemove', function (e) {
        if (!lbImg.classList.contains('zoomed')) return;
        var r = lbImg.getBoundingClientRect();
        var x = ((e.clientX - r.left) / r.width) * 100;
        var y = ((e.clientY - r.top)  / r.height) * 100;
        lbImg.style.transformOrigin = x + '% ' + y + '%';
      });
      document.addEventListener('keydown', function (e) {
        if (!lightbox.classList.contains('active')) return;
        if (e.key === 'Escape') closeLightbox();
        if (e.key === 'ArrowRight') lbStep(1);
        if (e.key === 'ArrowLeft') lbStep(-1);
      });
    }

    var finishingChk = document.getElementById('finishing-check');
    var shipLine     = document.getElementById('ship-line');
    var shipMini     = document.getElementById('ship-mini');
    var priceMain    = document.querySelector('.price');
    var priceMini    = document.getElementById('price-mini');
    function fmt(n) { return '₹' + n.toLocaleString('en-IN'); }
    function baseShip() {
      if (!HAS_STOCK) return { text: 'Made to order · ships in 6–8 weeks', days: null };
      var h = new Date().getHours();
      return (h >= CUTOFF_START && h < CUTOFF_END)
        ? { text: 'Ready to ship today', days: 0, miniText: 'Ready to ship today' }
        : { text: 'Ships tomorrow',      days: 1, miniText: 'Ships tomorrow' };
    }
    function update() {
      var withFinishing = finishingChk && finishingChk.checked;
      var total = BASE_PRICE + (withFinishing ? FINISHING_PRICE : 0);
      if (priceMain && BASE_PRICE > 0) priceMain.textContent = fmt(total);
      if (priceMini && BASE_PRICE > 0) priceMini.textContent = fmt(total);
      var base = baseShip(); var line, mini;
      if (withFinishing && base.days !== null) {
        var d = base.days + Math.ceil(FINISHING_HOURS / 24);
        line = 'Ships in ' + d + ' day' + (d === 1 ? '' : 's') + ' · with finishing'; mini = line;
      } else {
        line = base.text + (base.days !== null ? ' · DDP' : ''); mini = base.miniText || base.text;
      }
      if (shipLine) shipLine.textContent = line;
      if (shipMini) shipMini.textContent = mini;
    }
    if (finishingChk) finishingChk.addEventListener('change', update);
    update();
    setInterval(update, 5 * 60 * 1000);

    function getViewerCount(sku) {
      var cacheKey = 'sw_viewers_' + sku;
      var cached = sessionStorage.getItem(cacheKey);
      if (cached !== null) return parseInt(cached, 10);
      var lastRaw = sessionStorage.getItem('sw_viewers_last');
      var lastCount = lastRaw !== null ? parseInt(lastRaw, 10) : null;
      var max = 17; if (lastCount !== null) max = Math.max(2, Math.floor(lastCount * 0.6));
      var min = 2; var count, tries = 0;
      do { count = Math.floor(Math.random() * (max - min + 1)) + min; tries++; } while (count === lastCount && tries < 8 && max > min);
      sessionStorage.setItem(cacheKey, String(count));
      sessionStorage.setItem('sw_viewers_last', String(count));
      return count;
    }
    var viewersEl = document.getElementById('viewers-count');
    if (viewersEl) {
      var baseCount = getViewerCount(PRODUCT_SKU);
      var viewers = baseCount;
      viewersEl.textContent = viewers;
      setInterval(function () {
        if (Math.random() > 0.35) return;
        var delta = Math.random() < 0.5 ? -1 : 1;
        viewers = Math.max(2, Math.min(baseCount + 2, viewers + delta));
        viewersEl.classList.add('flash');
        setTimeout(function () { viewersEl.textContent = viewers; viewersEl.classList.remove('flash'); }, 220);
      }, 9000);
    }

    function transformCta(ctaRow) {
      ctaRow.classList.add('split');
      var addBtnEl = document.getElementById('add-to-bag');
      if (addBtnEl) {
        addBtnEl.outerHTML =
          '<button type="button" class="secondary btn-fade-in" id="continue-shopping">Continue Shopping</button>' +
          '<a href="/checkout" class="btn-primary btn-fade-in" id="checkout">Checkout</a>';
        var cont = document.getElementById('continue-shopping');
        if (cont) cont.addEventListener('click', function () { window.location.href = '/collections/sarees'; });
      }
    }
    function refreshCartUI() {
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var count = cart.item_count;
          ['[data-cart-count]', '.cart-count-bubble span', '.cart-count', '#CartCount', '.header__cart-count', '.site-header__cart-count']
            .forEach(function (sel) {
              document.querySelectorAll(sel).forEach(function (el) {
                el.textContent = count;
                if (count > 0) el.classList.remove('hidden');
              });
            });
          document.dispatchEvent(new CustomEvent('cart:refresh', { detail: cart }));
          document.documentElement.dispatchEvent(new CustomEvent('cart:build'));
        })
        .catch(function () {});
    }

    var addForm = document.getElementById('stuti-add-form');
    if (addForm) {
      addForm.addEventListener('submit', function (e) {
        e.preventDefault();
        var btn = document.getElementById('add-to-bag');
        if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
        var fd = new FormData(addForm);
        var sareeVariantId = fd.get('id');
        var withFinishing = finishingChk && finishingChk.checked;
        var items;
        if (withFinishing) {
          var token = 'fnh_' + Date.now().toString(36) + Math.random().toString(36).slice(2, 8);
          items = [
            { id: Number(sareeVariantId), quantity: 1, properties: { '_finishing_token': token } },
            { id: FINISHING_VARIANT_ID, quantity: 1, properties: { '_finishing_token': token } }
          ];
        } else {
          items = [{ id: Number(sareeVariantId), quantity: 1 }];
        }
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ items: items })
        })
        .then(function (r) { if (!r.ok) return r.json().then(function (err) { throw err; }); return r.json(); })
        .then(function () {
          var ctaRow = document.getElementById('cta-row');
          if (ctaRow) transformCta(ctaRow);
          refreshCartUI();
        })
        .catch(function (err) {
          if (btn) { btn.disabled = false; btn.textContent = 'Add to bag'; }
          var msg = (err && err.description) || (err && err.message) || 'Could not add to cart. Please try again.';
          alert(msg);
        });
      });
    }

  });
})();
